import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper from "swiper/bundle";

export default class Silder {
    constructor(dom) {
        window.addEventListener("resize", () => this.resize());
        this.dom = dom

        this.el_id = Math.floor(Math.random() * 99999)
        this.dom.dataset.id = this.el_id
    }

    init() {
        const type = this.dom.dataset.type

        switch (type) {
        case '_home_hero':
            this.homeHeroSlider()
            break;
        case '_month_days':
            this.homeMonthDays()
            break;
        case '_programme_list':
            this.homeProgrammeList()
            break;
        case '_images':
            this.imageSlider()
            break;
        case '_news-images':
            this.newsImageSlider()
            break;
        case '_trailers':
            this.trailerSlider()
            break;
        default:
            break;
        }

        // ScrollTrigger.refresh()
        setTimeout(() => {
        ScrollTrigger.refresh()
        }, 1000)
    }

    homeHeroSlider() {
        const select_slides = this.dom.querySelectorAll('.select-slide:not(._active)')
        const select_slide_active = this.dom.querySelector('.select-slide._active')

        let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
        spaceBetween: 0,
        slidesPerView: 1,
        // observer: true,
        // observeParents: true,
        });
        let mainSlider = new Swiper(this.dom.querySelector('.content-slider'), {
        spaceBetween: 0,
        speed: 650,
        // observer: true,
        // observeParents: true,

        });

        thumbSlider.controller.control = mainSlider;
        mainSlider.controller.control = thumbSlider;

        mainSlider.on('slideChange', (swiper) => {
        // console.log(swiper.realIndex);
        select_slide_active.style.setProperty("--index", swiper.realIndex);
        })

        select_slides.forEach((item, i) => {
        const to_index = item.dataset.index
        item.addEventListener('click', () => {
            mainSlider.slideTo(to_index)
        })
        });

    }

    homeMonthDays() {
        let monthSlider = new Swiper(this.dom.querySelector('.month_days'), {
            spaceBetween: 8,
            slidesPerView: 'auto',
            navigation: {
                nextEl: this.dom.querySelector('.btn-next'),
                prevEl: this.dom.querySelector('.btn-prev'),
            },
        });

        document.addEventListener('handleSliderMonthDays', (e) => {
        if (e.detail.id != this.el_id) {
            return
        }
        switch (e.detail.type) {
            case 'reset':
            monthSlider = new Swiper(e.detail.el.querySelector('.month_days'), {
                spaceBetween: 8,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: e.detail.el.querySelector('.btn-next'),
                    prevEl: e.detail.el.querySelector('.btn-prev'),
                },
            });
            break;
            default:
            break;
        }
        }, false)
    }

    homeProgrammeList() {
        let programmeSlider = new Swiper(this.dom.querySelector('.programme_list'), {
            spaceBetween: 20,
            slidesPerView: 1.5,
            breakpoints: {
                769: {
                spaceBetween: 40,
                slidesPerView: 3.7,
                }
            },
            navigation: {
                nextEl: this.dom.querySelector('.btn-next'),
                prevEl: this.dom.querySelector('.btn-prev'),
            },
        });

        document.addEventListener('handleSliderProgrammeList', (e) => {
        if (e.detail.id != this.el_id) {
            return
        }
        switch (e.detail.type) {
            case 'filter':
            programmeSlider.updateSize();
            programmeSlider.updateSlides();
            programmeSlider.updateProgress();
            programmeSlider.updateSlidesClasses();
            programmeSlider.slideTo(0);
            programmeSlider.scrollbar.updateSize();
            break;

            case 'reset':
            programmeSlider = new Swiper(e.detail.el.querySelector('.programme_list'), {
                spaceBetween: 20,
                slidesPerView: 1.5,
                breakpoints: {
                    769: {
                        spaceBetween: 40,
                        slidesPerView: 3.7,
                    }
                },
                navigation: {
                    nextEl: e.detail.el.querySelector('.btn-next'),
                    prevEl: e.detail.el.querySelector('.btn-prev'),
                },
            });
            break;
            default:
            break;
        }
        }, false)
    }

    imageSlider() {
        let thumbSlider2 = new Swiper(this.dom.querySelector('.thumb-slider2'), {
            spaceBetween: 14,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,

        });

        let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
            spaceBetween: 30,
            slidesPerView: 'auto',
            freeMode: true,
            breakpoints: {
                // 769: {
                //   slidesPerView: 1.5,
                // }
            },
            // observer: true,
            // observeParents: true,
            thumbs: {
                swiper: thumbSlider2,
            },
            navigation: {
                nextEl: this.dom.querySelector('.thumb-slider .btn-next'),
                prevEl: this.dom.querySelector('.thumb-slider .btn-prev'),
            },
            on: {
                init: () => {
                    this.dom.querySelectorAll('.thumb-slider .item').forEach(item => {
                        const el_caption = item.querySelector('.caption')
                        if (el_caption) {
                            el_caption.style.maxWidth = `${item.querySelector('.img-wrap img').offsetWidth}px`
                        }
                    })
                },
                resize: () => {
                    this.dom.querySelectorAll('.thumb-slider .item').forEach(item => {
                        const el_caption = item.querySelector('.caption')
                        if (el_caption) {
                            el_caption.style.maxWidth = `${item.querySelector('.img-wrap img').offsetWidth}px`
                        }
                    })
                }
            }
        });



        // thumbSlider.controller.control = thumbSlider2;
        // thumbSlider2.controller.control = thumbSlider;
    }

    newsImageSlider() {
        let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
            spaceBetween: 40,
            slidesPerView: 1.9,
        });
    }

    trailerSlider() {
        let trailerSlider = new Swiper(this.dom.querySelector('.trailers'), {
            spaceBetween: 20,
            slidesPerView: 1.5,
            breakpoints: {
                769: {
                    spaceBetween: 40,
                    slidesPerView: 2.5,
                }
            }
        });
    }

    initResponsiveHelper() {

    }

    resize() {
    }

}
